<template>
  <div>
    <h1>Exercise manager</h1>
    <p> I am an mathematical exercise please edit me.</p>
  </div>

</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
  },
  methods: {
  },
  components: {
  },
  mounted () {
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// ExerciseManager.vue?7ec2dd83